import './Login.css'
import { FormEvent, ReactNode, useState } from 'react'
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { APIRequestPost } from '../utils/APIRequests';
import { UserRegisterRequestData } from '../api/User';

function Register(): ReactNode {
    const { t } = useTranslation(['register', 'base']);

    const [emailValue, setEmailValue] = useState<string>("");
    const [passwordValue, setPasswordValue] = useState<string>("");

    // const [errorInfo, setErrorInfo] = useState<ReactNode>(<div></div>);
    const [errorText, setErrorText] = useState<string>("");
    const [enabledButton, setEnabledButton] = useState<boolean>(true);

    const isAstra = process.env.REACT_APP_SERVICE === 'astra';

    function submitForm(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault();

        setEnabledButton(false);

        const data: UserRegisterRequestData = {
            email: emailValue,
            password: passwordValue
        };

        APIRequestPost(`/auth/register`, {
            data: data,
            logSuccess: true
        }).then(() => {
            window.location.href = "/confirm-email";
            setEnabledButton(true);
        }).catch((error) => {
            // setErrorInfo(<div style={{ color: "red", paddingTop: "10px" }}>Such an email already exists, or different passwords have been entered.</div>)
            if (error.response.status === 400) {
                setErrorText(error.response.data);
                console.log(error.response.data);
            }
            setEnabledButton(true)
        });
    }

    return (
        <div className='form-page'>
            <div className='form-page-container'>
                {isAstra ? (
                    <div className='console-logo'>
                        <img className='astra-icon' src="/image/astra/astra_logo.svg" alt="" />
                    </div>
                ) : (
                    <div className='console-logo'>Air-link Console</div>
                )}
                <Form onSubmit={submitForm}>
                    <Form.Group className="login-form" controlId="formBasicEmail">
                        <Form.Label>{t('address', { ns: "register" })}</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter email"
                            value={emailValue}
                            onChange={e => setEmailValue(e.currentTarget.value)}
                        />
                    </Form.Group>

                    <Form.Group className="login-form" controlId="formBasicPassword">
                        <Form.Label>{t('password', { ns: "register" })}</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Password"
                            value={passwordValue}
                            onChange={e => setPasswordValue(e.currentTarget.value)}
                        />
                    </Form.Group>
                    
                    <Button variant="light" type="submit" disabled={!enabledButton}>
                        {t('Register', { ns: "base" })}
                    </Button>
                </Form>
                <div style={{ color: "red", paddingTop: "10px" }}>{t(errorText, { ns: "register" })}</div>
            </div>
        </div>
    )
}

export default Register;
